import React, { useEffect, useState } from "react";

import {
  Button,
  Dialog,
  Grid,
  Slide,
  Typography,
  IconButton,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import TransferList from "./TransferList";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxhook";
import {
  addFilesToCollection,
  addImagesToCollection,
  getcollection,
} from "../../redux/slices/collectionSlice";
import apiCall from "../../utils/apiCall";
import {
  ADD_IMAGES,
  CREATE_INDEX,
  DELETE_IMAGE,
  DELETE_INDEX,
  GET_IMAGES,
  GET_INDEXES,
  UPDATE_COLLECTION,
} from "../../endpoint";
import ArticleIcon from "@mui/icons-material/Article";
import ImageIcon from "@mui/icons-material/Image";
import { IMAGE, PDF } from "../../data/constants";
import UploadImagePdf from "../UploadImagePdf";
import { addError } from "../../redux/slices/errorSlice";
import { Close } from "@mui/icons-material";
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const TransferListModal = ({
  open,
  setOpen,
  refreshstate,
}: {
  open: boolean;
  setOpen: any;
  refreshstate: () => void;
}) => {
  const handleClose = () => {
    setOpen();
  };

  const initial_upload_state = {
    open: false,
    loadurl: "",
    deleteurl: "",
    type: "",
  };

  const collection = useAppSelector(getcollection);

  const dispatch = useAppDispatch();

  const [uploadInfo, setUploadInfo] = useState(initial_upload_state);
  const [files, setFiles] = useState([]);
  const [images, setImages] = useState([]);
  const [refresh, setrefresh] = useState(false);

  useEffect(() => {
    apiCall("POST", GET_INDEXES)
      .then((res) => {
        setFiles(res.result);
      })
      .catch((err) => {
        dispatch(addError("Failed to fetch the files.Please try again."));
      });
    apiCall("POST", GET_IMAGES)
      .then((res) => {
        setImages(res.result);
      })
      .catch((err) => {
        dispatch(addError("Failed to fetch the images.Please try again."));
      });
  }, [refresh]);

  const updateCollection = () => {
    if (!collection.name || !/[a-zA-Z]/.test(collection.name)) {
      dispatch(addError("Collection name cannot be empty and must contain letters."));
      return;
    }
  
    const file_list = [
      ...collection.files.map((file) => ({
        file_name: file,
        file_type: "doc",
      })),
      ...collection.images.map((img) => ({
        file_name: img,
        file_type: "img",
      })),
    ];
    apiCall("POST", UPDATE_COLLECTION, {
      folder_name: collection.name,
      file_list,
    })
      .then((res) => {
        handleClose();
        refreshstate();
      })
      .catch((err) => {
        dispatch(
          addError("Failed to update the collections.Please try again.")
        );
      });
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      fullWidth={true}
      maxWidth={"lg"}
      sx={{
        p: 2,
      }}
    >
      <IconButton
        aria-label="close"
        onClick={handleClose}
        size="small"
        sx={{
          position: "absolute",
          right: 2,
          top: 2,
        }}
      >
        <Close sx={{ color: "gray" }}   />
      </IconButton>
      <Typography
        mx={4}
        mt={4}
        sx={{
          paddingBottom: 0.5,
        }}
        
      >
        Collection name
      </Typography>
      <Typography
        sx={{
          mx: 4,
          paddingBottom: 0.5,
          borderBottom: "1px solid rgba(0,0,0,0.1)",
        }}
      >
        {collection.name}
      </Typography>
      <Grid container>
        <Grid
          container
          item
          xs={6}
          sx={{
            borderRight: "1px solid rgba(0,0,0,.1)",
            my: 1,
          }}
        >
          <Button
            sx={{
              ml: "auto",
              mr: 1,
            }}
            startIcon={<ArticleIcon />}
            variant="outlined"
            size="small"
            color="secondary"
            onClick={() =>
              setUploadInfo({
                open: true,
                loadurl: CREATE_INDEX,
                deleteurl: DELETE_INDEX,
                type: PDF,
              })
            }
          >
            Upload documents
          </Button>
          <TransferList
            fileListLeft={files}
            fileListRight={collection.files}
            dispatchAdd={(element) => dispatch(addFilesToCollection(element))}
          />
        </Grid>
        <Grid container item xs={6} sx={{ my: 1 }}>
          <Button
            sx={{
              ml: "auto",
              mr: 1,
            }}
            startIcon={<ImageIcon />}
            variant="outlined"
            size="small"
            color="secondary"
            onClick={() =>
              setUploadInfo({
                open: true,
                loadurl: ADD_IMAGES,
                deleteurl: DELETE_IMAGE,
                type: IMAGE,
              })
            }
          >
            Upload Images
          </Button>
          <TransferList
            fileListLeft={images}
            fileListRight={collection.images}
            dispatchAdd={(element) => dispatch(addImagesToCollection(element))}
          />
        </Grid>
      </Grid>
      <Button
        variant="contained"
        sx={{
          mx: "auto",
          my: 2,
          width: "95%",
        }}
        onClick={updateCollection}
        disabled={
          collection.files.length == 0 && collection.images.length === 0
        }
      >
        Update Collection
      </Button>
      <UploadImagePdf
        open={uploadInfo.open}
        setOpen={() => setUploadInfo(initial_upload_state)}
        deleteurl={uploadInfo.deleteurl}
        uploadurl={uploadInfo.loadurl}
        type={uploadInfo.type}
        refresh={() => setrefresh(!refresh)}
        filelist={files}
        imagelist={images}
      />
    </Dialog>
  );
};

export default TransferListModal;
